module.exports = __webpack_public_path__ + "download/static/img/float_1.96d80664.png";